/**
 * Procedure Categories and Procedures for Diploma in Clinical Pathology students
 * Extracted with strict evidence from official NMC PDF
 */
export const CLINICAL_PATHOLOGY_PROCEDURES = {
  "Specimen Collection & FNA": [
    "Venipuncture",
    "Finger-Prick",
    "Fine Needle Aspiration (FNA) of Superficial Lumps",
    "Selection and Bleeding of Blood Donors",
  ],
  "Histopathology & Surgical Pathology": [
    "Gross Examination of Tissues & Taking Appropriate Tissue Sections",
    "Grossing of Simple Specimens",
    "Tissue Processing",
    "Paraffin Block Preparation",
    "Paraffin Section Cutting Using Rotary Microtome",
    "Frozen Section Cutting",
    "Haematoxylin and Eosin (H&E) Staining",
    "Iron Staining",
    "Acid-Fast (AFB) Staining",
    "Performing Autopsies",
  ],
  Cytopathology: [
    "Cytopathology Smear Preparation",
    "Giemsa Staining for Cytopathology",
    "Pap (Papanicolaou) Staining for Cytopathology",
  ],
  "Haematology & Blood Banking": [
    "Haemogram (including Reticulocyte and Platelet Counts)",
    "Blood Smear Staining",
    "Bone Marrow Staining (including Iron Stain)",
    "Hemolytic Anemia Profile (including HPLC & Hb Electrophoresis)",
    "Coagulation Profile (including PT, APTT, and FDP)",
    "ABO Blood Grouping",
    "Rh Blood Grouping",
  ],
  "Microbiology Laboratory Procedures": [
    "Gram's Staining",
    "Ziehl–Neelsen (AFB) Staining",
    "Hanging Drop Preparation",
    "KOH / Lactophenol Preparation for Fungi",
  ],
  "Clinical Biochemistry & Reagent Preparation": [
    "Quantitative Estimation of Blood Sugar",
    "Quantitative Estimation of Blood Urea",
    "Quantitative Estimation of Serum Proteins (Total and Fractional)",
    "Quantitative Estimation of Serum Bilirubin (Total and Fractional)",
    "Quantitative Estimation of Serum Creatinine",
    "Quantitative Estimation of Serum Transaminases (ALT/AST, SGOT, SGPT)",
    "Quantitative Estimation of Alkaline Phosphatase",
    "Quantitative Estimation of Serum Cholesterol",
    "Quantitative Estimation of Uric Acid",
    "Preparation of Standard Solutions and Reagents",
    "Preparation of Normal Solutions, Molar Solutions, and Buffers",
  ],
};

export const CLINICAL_PATHOLOGY_CATEGORIES = Object.keys(CLINICAL_PATHOLOGY_PROCEDURES);

export const isDiplomaInClinicalPathologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("clinical") && d.includes("pathology");
};
